export default {
  track (VueApp, data, callback) {
    // return
    data.brandId = VueApp.$store.state.brandId
    data.deviceType = 'ww'
    VueApp.$sdk.opt('/errors/booking', data, r => {
      if (r.error) {
        console.log('/errors/booking', r)
        return
      }
      console.log('Booking error tracked')
      if (callback) callback(r)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/track-error.js